export const selectLogin = state => state.login;
